"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLargeSprite = exports.createLargeSprite = exports.createBigImage = exports.createImageFromFrame = exports.createMixed = exports.createImageShrink = exports.createImage = exports.getPackedFrame = exports.getPackedFrameShrink = exports.getSspTexture = exports.createAnimImage = exports.createAnimFrame = exports.createManualFrame = exports.copyXY = exports.setPackedFrameProgress = exports.scaleProgressCentered = exports.scale = exports.setManualFrame = exports.setPackedFrameSameScale = exports.setPackedFrameShrink = exports.setPackedFrame = exports.destroyImages = exports.setDefaultScale = void 0;
var assert_sidecar_1 = require("../lib/assert-sidecar");
var common_sidecar_1 = require("../main/common-sidecar");
var defaultScale = 4;
var setDefaultScale = function (scale) {
    defaultScale = scale;
};
exports.setDefaultScale = setDefaultScale;
var destroyImages = function (images) {
    for (var i = 0; i < images.length; i++) {
        images[i].destroy();
    }
};
exports.destroyImages = destroyImages;
var setPackedFrame = function (image, fi) {
    var frame = getPackedFrame(fi);
    image.frame = frame;
    image.setScale(defaultScale / (fi.s || 1));
    image.setDisplayOrigin(frame.width * 0.5, frame.height * 0.5);
    image.fi = fi;
};
exports.setPackedFrame = setPackedFrame;
var setPackedFrameShrink = function (image, fi) {
    var frame = getPackedFrameShrink(fi);
    image.frame = frame;
    image.setScale(defaultScale / (fi.s || 1));
    image.setDisplayOrigin(frame.width * 0.5, frame.height * 0.5);
    image.fi = fi;
};
exports.setPackedFrameShrink = setPackedFrameShrink;
var setPackedFrameSameScale = function (image, fi) {
    var sx = image.scaleX;
    var sy = image.scaleY;
    var frame = getPackedFrame(fi);
    image.frame = frame;
    image.setScale(sx, sy);
    image.setDisplayOrigin(frame.width * 0.5, frame.height * 0.5);
    image.fi = fi;
};
exports.setPackedFrameSameScale = setPackedFrameSameScale;
var setManualFrame = function (image, fi) {
    var frame = createManualFrame(fi, image.texture);
    image.frame = frame;
    // image.setScale(defaultScale)
    // image.setDisplayOrigin(frame.width * 0.5, frame.height * 0.5)
};
exports.setManualFrame = setManualFrame;
var scale = function (image, scale) {
    if (image.fi && image.fi.s) {
        scale = scale / image.fi.s;
    }
    image.scale = scale;
};
exports.scale = scale;
var scaleProgressCentered = function (image, scale, progress) {
    if (progress < 0) {
        progress = 0;
    }
    if (progress > 1) {
        progress = 1;
    }
    image.scaleY = scale;
    image.scaleX = scale * progress;
};
exports.scaleProgressCentered = scaleProgressCentered;
var setPackedFrameProgress = function (image, fis, progress) {
    var frameNum = Math.round(fis.length * progress);
    if (frameNum < 0) {
        frameNum = 0;
    }
    if (frameNum >= fis.length) {
        frameNum = fis.length - 1;
    }
    exports.setPackedFrame(image, fis[frameNum]);
};
exports.setPackedFrameProgress = setPackedFrameProgress;
var copyXY = function (dest, src) {
    dest.x = src.x;
    dest.y = src.y;
};
exports.copyXY = copyXY;
var manualFrameIdx = 100;
function createManualFrame(fi, tex) {
    var f = new Phaser.Textures.Frame(tex, "mframe-" + ++manualFrameIdx, 0, fi.x, fi.y, fi.w, fi.h);
    return f;
}
exports.createManualFrame = createManualFrame;
var _animFrameNum = 0;
function createAnimFrame(tex, fd) {
    var f = new Phaser.Textures.Frame(tex, _animFrameNum++, 0, fd.px, fd.py, fd.pw, fd.ph);
    f.setTrim(fd.sw, fd.sh, fd.tx, fd.ty, fd.tw, fd.th);
    return f;
}
exports.createAnimFrame = createAnimFrame;
function createAnimImage(layer) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var image = scene.add.image(0, 0, getSspTexture(0));
    layer.add(image);
    image.setOrigin(0, 0);
    image.width = 10;
    image.height = 10;
    // image.frame = frame
    image.originX = 0.5;
    image.originY = 0.5;
    image.x = 0;
    image.y = 0;
    image.scale = defaultScale;
    // image.setDisplayOrigin(frame.width / 2, frame.height / 2)
    return image;
}
exports.createAnimImage = createAnimImage;
var _sspTextures = [];
function getSspTexture(idx) {
    if (!_sspTextures[idx]) {
        var scene = common_sidecar_1.common.getPhaserScene();
        _sspTextures[idx] = scene.game.textures.get('ssp' + idx);
        assert_sidecar_1.assert.notNil(_sspTextures[idx]);
    }
    return _sspTextures[idx];
}
exports.getSspTexture = getSspTexture;
var __sspFrameIndex = 0;
function getPackedFrameShrink(fi) {
    return getPackedFrame(fi, true);
}
exports.getPackedFrameShrink = getPackedFrameShrink;
function getPackedFrame(fi, shrink) {
    if (shrink === void 0) { shrink = false; }
    assert_sidecar_1.assert.notNil(fi);
    var frame = fi.f;
    var shrinkX = 0;
    var shrinkY = 0;
    if (shrink) {
        // shrinkX = 1
        // shrinkY = 1
    }
    if (!frame) {
        __sspFrameIndex++;
        if (fi.t === 1) {
            //} && fi.x === sprites.underIconHealth[0].x) {
            // console.log('loaded trim', fi)
            var f = new Phaser.Textures.Frame(getSspTexture(fi.i), __sspFrameIndex, //`ssp-${fi.p}-${fi.x}-${fi.y}-${fi.w}-${fi.h}`,
            0, 
            // fi.x + (fi.tx || 0) + shrinkX,
            // fi.y + (fi.ty || 0) + shrinkY,
            // (fi.tw || 0) - shrinkX * 2,
            // (fi.th || 0) - shrinkY * 2,
            fi.x + shrinkX, fi.y + shrinkY, (fi.tw || 0) - shrinkX * 2, (fi.th || 0) - shrinkY * 2);
            // f.setTrim(fi.w, fi.h, fi.tx || 0, fi.ty || 0, fi.tw || 0, fi.th || 0)
            //f.setTrim(fi.w, fi.x, fi.tx || 0, fi.ty || 0, fi.tw || 0, fi.th || 0)
            f.setTrim(fi.w, fi.h, fi.tx || 0, fi.ty || 0, fi.tw || 0, fi.th || 0);
            fi.f = f;
            return f;
        }
        else {
            var f = new Phaser.Textures.Frame(getSspTexture(fi.i), __sspFrameIndex, //`ssp-${fi.p}-${fi.x}-${fi.y}-${fi.w}-${fi.h}`,
            0, fi.x + shrinkX, fi.y + shrinkY, fi.w - shrinkX * 2, fi.h - shrinkY * 2);
            fi.f = f;
            return f;
        }
    }
    return frame;
}
exports.getPackedFrame = getPackedFrame;
function createImage(layer, fi) {
    var img = createImageFromFrame(layer, getPackedFrame(fi));
    img.fi = fi;
    if (fi.s) {
        img.scale = img.scale / fi.s;
    }
    return img;
}
exports.createImage = createImage;
function createImageShrink(layer, fi) {
    var img = createImageFromFrame(layer, getPackedFrameShrink(fi));
    img.fi = fi;
    if (fi.s) {
        img.scale = img.scale / fi.s;
    }
    return img;
}
exports.createImageShrink = createImageShrink;
function createMixed(layer, fi, largeSprite) {
    assert_sidecar_1.assert.f(fi != null && largeSprite != null, 'you cannot have everything');
    if (fi) {
        return createImage(layer, fi);
    }
    if (largeSprite) {
        return createLargeSprite(layer, largeSprite);
    }
    assert_sidecar_1.assert.failed('no valid data');
    throw new Error('!');
}
exports.createMixed = createMixed;
function createImageFromFrame(layer, frame) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var image = scene.add.image(0, 0, '');
    layer.add(image);
    image.width = frame.width;
    image.height = frame.height;
    image.frame = frame;
    image.originX = 0.5;
    image.originY = 0.5;
    image.x = 0;
    image.y = 0;
    image.scale = defaultScale;
    image.setDisplayOrigin(frame.width / 2, frame.height / 2);
    return image;
}
exports.createImageFromFrame = createImageFromFrame;
function createBigImage(layer, tex) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var image = scene.add.image(0, 0, tex);
    image.setOrigin(0, 0);
    image.x = 0;
    image.y = 0;
    image.scale = defaultScale;
    layer.add(image);
    return image;
}
exports.createBigImage = createBigImage;
function createLargeSprite(layer, ls) {
    var scene = common_sidecar_1.common.getPhaserScene();
    var image = scene.add.image(0, 0, ls.k);
    image.setOrigin(0, 0);
    image.x = 0;
    image.y = 0;
    image.scale = defaultScale;
    layer.add(image);
    return image;
}
exports.createLargeSprite = createLargeSprite;
function setLargeSprite(image, ls) {
    image.setTexture(ls.k);
    // image.setOrigin(0, 0)
    return image;
}
exports.setLargeSprite = setLargeSprite;
